import { Answer, MultipleChoiceContent, Score } from "../types";

export function markAnswer(
  content: MultipleChoiceContent,
  answer: Answer
): Score {
  if (!answer) {
    return {
      score: 0
    };
  } else {
    return {
      score: answer.index === content.correctAnswerIndex ? 1 : 0
    };
  }
}
